import { Box, Divider, TextLink, Typography } from "@drone-js/core";
import { replaceCms } from "apps/commons/functions/replaceCms";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";
import { usePropertiesValue } from "./propertiesAtom";
import { selectablePropertiesFilter } from "./selectablePropertiesFilter";
import { useSelectedPropertiesValue, useSetSelectedProperties } from "./selectedPropertiesAtom";

export const ListingControls = () => {
    const {
        automaticPropertySelectionCms: {
            clearSelection,
            selectAll,
            pageListingsSelectedSingular,
            pageListingsSelectedPlural,
        },
    } = usePropertySelectionViewModelValue();

    const properties = usePropertiesValue();
    const selectedProperties = useSelectedPropertiesValue();
    const setSelectedProperties = useSetSelectedProperties();

    const propertiesOfInterest = properties.filter(selectablePropertiesFilter);

    const handleClick = () => {
        // if user click when all properties are selected, clear all
        if (selectedProperties.length === propertiesOfInterest.length) setSelectedProperties([]);
        else setSelectedProperties(propertiesOfInterest.map((p) => p.id));
    };

    if (propertiesOfInterest.length === 0) return null;

    // hide when avail options length is 0
    return (
        <Box
            display="flex"
            justifyContent="start"
            alignItems="center"
            mt="16"
            qM={{
                mt: "0",
                justifyContent: "end",
            }}
        >
            <Typography variant="body-s" textColor="base.subtle">
                {replaceCms(
                    selectedProperties.length > 1 ? pageListingsSelectedPlural : pageListingsSelectedSingular,
                    selectedProperties.length,
                )}
            </Typography>
            <Box height="16px" px="8">
                <Divider direction="vertical" />
            </Box>
            <TextLink
                data-element-name="universal-selection"
                hierarchy="primary"
                label={selectedProperties.length === propertiesOfInterest.length ? clearSelection : selectAll}
                onClick={handleClick}
            />
        </Box>
    );
};
